// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".fa[data-v-a9426c02] {\n  color: #0a6aa1;\n  display: block;\n}\n.sheng[data-v-a9426c02] {\n  color: #ff0000;\n  display: block;\n}", ""]);
// Exports
module.exports = exports;
